

export class Common {
  static GOOGLE_MAPS_ANDROID_API_KEY = "AIzaSyByiJ_ktcragpmcbeJKnX98iwyJ9r21rNI";
}
